/**
 * ModalContextHeader Component
 * 
 * Shared component for displaying store/campaign/assignment context in modals
 */

import { cn } from '@/lib/utils';

interface ModalContextHeaderProps {
  storeName: string;
  campaignName?: string;
  assignmentId?: number;
  className?: string;
}

export function ModalContextHeader({ 
  storeName, 
  campaignName, 
  assignmentId,
  className 
}: ModalContextHeaderProps) {
  return (
    <div className={cn("border-b pb-2 mb-3", className)}>
      <p className="text-sm font-medium">{storeName}</p>
      {campaignName && (
        <p className="text-xs text-muted-foreground">{campaignName}</p>
      )}
      {assignmentId && (
        <p className="text-xs text-muted-foreground">Assignment ID: {assignmentId}</p>
      )}
    </div>
  );
}





